export const titles: { [index: string]: string } = {
  quizzes: 'Quizzes',
  actions: 'Actions',
  'co2-scan': 'CO2 Scans',
  'user-interests': 'User interests',
};

export interface Statistics {
  label: string;
  stackedValues: StackedValue[];
}

export interface StackedValue {
  label: string;
  value: number;
}
